<div class="container-fluid p-0" style="background-color: #F8F8FF;">
  <div class="row g-0">
    <!-- Side Nav -->
    <div class="col-auto">
      <app-side-nav></app-side-nav>
    </div>

    <!-- Main Content -->
    <div class="col">
      <div class="container mt-2 px-3">
        <div class="card study-details-card">
          <div class="card-body">

            <!-- Heading + Back Button -->
            <div class="row align-items-center mb-3">
              <div class="col-12 col-md-6">
                <h5 class="study-heading mb-2 mb-md-0">Study Details</h5>
              </div>
              <div class="col-12 col-md-6 text-md-end">
                <button class="btn custom-button mb-2 mb-md-0" (click)="goBack()">
                  Back
                </button>
              </div>
            </div>

            <!-- Study Info Card -->
            <div class="card new-card mb-2">
              <div class="card-body py-0">
                <div class="row gy-2">
                  <div class="col-12 col-md-4 text-start">
                    <strong>Study Code:</strong> {{ studyDetails?.study_code }}
                  </div>
                  <div class="col-12 col-md-4 text-center">
                    <strong>Study Name:</strong> {{ studyDetails?.study_name }}
                  </div>
                  <div class="col-12 col-md-4 text-end">
                    <strong>Site Location:</strong> {{ studyDetails?.site_location }}
                  </div>
                </div>
              </div>
            </div>

            <!-- Instruction + Add Subject Button -->
            <div class="row align-items-center g-2 mb-3">
              <div class="col-12 col-md-8">
                <p class="subject-instruction mb-0">
                  Click on <strong>Screening ID</strong> to visit the eCRF.
                </p>
              </div>
              <div class="col-12 col-md-4 text-md-end" *ngIf="canAddDeleteSubjects">
                <button
                  type="button"
                  class="btn custom-button add-subject-btn"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                >
                  Add Participant
                </button>
              </div>
            </div>

            <!-- Spinner -->
            <div
              *ngIf="loading"
              class="d-flex justify-content-center align-items-center py-3"
            >
              <div class="spinner-border text-purple" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>

            <!-- Table -->
            <div class="new-card mt-0 pt-0" *ngIf="!loading">
              <div class="table-wrapper table-responsive">
                <table class="table new-table mb-0 text-center align-middle">
                  <thead>
                    <tr>
                      <th scope="col"><b>S.No</b></th>
                      <th scope="col"><b>Screening ID</b></th>
                      <th scope="col"><b>PARTICIPANT ID</b></th>
                      <th scope="col"><b>Participant Initial</b></th>
                      <th scope="col" class="text-end"><b></b></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let user of groupedStudies; let i = index"
                      class="row-border"
                    >
                      <td>{{ i + 1 }}</td>
                      <td class="cursor-pointer">
                        <a (click)="viewSubject(user)">
                          {{ user.subjectId }}
                        </a>
                        <span *ngIf="user.is_frozen" class="badge bg-info ms-2">❄️ Frozen</span>
                        <span *ngIf="user.is_locked" class="badge bg-warning ms-2">🔒 Locked</span>
                      </td>
                      <td>{{ user.participantId || '-' }}</td>
                      <td>{{ user.subjectInitial || '-' }}</td>
                      <td class="text-end" *ngIf="canAddDeleteSubjects">
                        <div class="dropdown">
                          <button
                            type="button"
                            class="btn p-0 dropdown-toggle hide-arrow"
                            data-bs-toggle="dropdown"
                          >
                            <i class="bx bx-dots-vertical-rounded"></i>
                          </button>
                          <div class="dropdown-menu dropdown-menu-end">
                            <a
                              class="dropdown-item"
                              href="javascript:void(0);"
                              (click)="openEditSubject(user)"
                              *ngIf="!user.is_frozen && !user.is_locked"
                            >
                              <i class="bx bx-edit me-1"></i> Edit
                            </a>
                            <a
                              class="dropdown-item"
                              href="javascript:void(0);"
                              (click)="deleteSubject(user)"
                              *ngIf="!user.is_frozen && !user.is_locked"
                            >
                              <i class="bx bx-trash me-1"></i> Delete
                            </a>
                            <a
                              *ngIf="!user.is_locked && canManageFreezeLock()"
                              class="dropdown-item"
                              href="javascript:void(0);"
                              (click)="freezeSubject(user)"
                            >
                              <i class="bx bx-lock-open me-1" *ngIf="!user.is_frozen"></i>
                              <i class="bx bx-lock me-1" *ngIf="user.is_frozen"></i>
                              {{ user.is_frozen ? 'Unfreeze' : 'Freeze' }}
                            </a>
                            <a
                              *ngIf="!user.is_locked && canManageFreezeLock()"
                              class="dropdown-item"
                              [class.disabled]="user.is_locked"
                              href="javascript:void(0);"
                              (click)="!user.is_locked && lockSubject(user)"
                            >
                              <i class="bx bx-lock me-1"></i> Lock
                            </a>
                          </div>
                        </div>
                      </td>
                      <td *ngIf="!canAddDeleteSubjects"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div> <!-- card-body -->
        </div> <!-- card -->
      </div> <!-- container -->
    </div> <!-- col -->
  </div> <!-- row -->
</div> <!-- container-fluid -->


<!-- Modal -->
<div
  class="modal fade"
  id="exampleModal"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
  (hidden.bs.modal)="onModalClose()"
>
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header border-0 pb-0">
        <h4 class="modal-title fs-5 w-100" id="exampleModalLabel">
          ADD PARTICIPANTS HERE
        </h4>
      </div>

      <div class="modal-body pt-3">
        <form [formGroup]="subjectForm">
          <div class="mb-3">
            <label for="subjectId" class="form-label">Screening ID</label>
            <input
              type="text"
              class="form-control"
              id="subjectId"
              formControlName="subjectId"
              placeholder="Enter Screening ID"
            />
          </div>
          <div class="mb-3">
            <label for="participantId" class="form-label">PARTICIPANT ID</label>
            <input
              type="text"
              class="form-control"
              id="participantId"
              formControlName="participantId"
              placeholder="Enter Participant ID"
            />
          </div>
          <div class="mb-3">
            <label for="subjectInitial" class="form-label">Participant Initial</label>
            <input
              type="text"
              class="form-control"
              id="subjectInitial"
              formControlName="subjectInitial"
              placeholder="Enter Participant Initial"
            />
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn custom-button"
          data-bs-dismiss="modal"
          (click)="onModalClose()"
        >
          Close
        </button>
        <button
          type="button"
          class="btn custom-button"
          (click)="submitSubjectForm()"
        >
          Submit
        </button>
      </div>

    </div>
  </div>
</div>

<!-- Edit Subject Modal -->
<div
  class="modal fade"
  id="editSubjectModal"
  aria-labelledby="editSubjectModalLabel"
  aria-hidden="true"
  (hidden.bs.modal)="onEditModalClose()"
>
  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header border-0 pb-0">
        <h4 class="modal-title fs-5 w-100" id="editSubjectModalLabel">
          EDIT PARTICIPANT
        </h4>
      </div>

      <div class="modal-body pt-3">
        <form [formGroup]="editSubjectForm">
          <div class="mb-3">
            <label for="editSubjectId" class="form-label">Screening ID</label>
            <input
              type="text"
              class="form-control"
              id="editSubjectId"
              formControlName="subjectId"
            />
          </div>
          <div class="mb-3">
            <label for="editParticipantId" class="form-label">PARTICIPANT ID</label>
            <input
              type="text"
              class="form-control"
              id="editParticipantId"
              formControlName="participantId"
            />
          </div>
          <div class="mb-3">
            <label for="editSubjectInitial" class="form-label">Participant Initial</label>
            <input
              type="text"
              class="form-control"
              id="editSubjectInitial"
              formControlName="subjectInitial"
            />
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn custom-button"
          data-bs-dismiss="modal"
          (click)="onEditModalClose()"
        >
          Close
        </button>
        <button
          type="button"
          class="btn custom-button"
          (click)="submitEditSubjectForm()"
        >
          Update
        </button>
      </div>

    </div>
  </div>
</div>

<!-- Freeze/Unfreeze Subject Modal -->
<div
  class="modal fade"
  id="freezeSubjectModal"
  tabindex="-1"
  aria-labelledby="freezeSubjectModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content p-4">
      <h5 class="modal-title mb-3">
        {{ isFreezing ? 'Freeze Participant' : 'Unfreeze Participant' }}
      </h5>
      <div class="mb-3">
        <p class="text-muted">
          <strong>Screening ID:</strong> {{ currentSubject?.subjectId }}
        </p>
        <div class="alert alert-info" *ngIf="isFreezing">
          <small>
            Freezing this Participant will make it view-only. No changes or edits will be allowed until it is unfrozen.
          </small>
        </div>
        <div class="alert alert-success" *ngIf="!isFreezing">
          <small>
            Unfreezing this Participant will restore all editing capabilities.
          </small>
        </div>
      </div>
      <div class="mb-3">
        <label for="freezeEmail" class="form-label">Email:</label>
        <input
          type="email"
          class="form-control"
          id="freezeEmail"
          [(ngModel)]="freezeEmail"
          placeholder="Enter your email"
          (keyup.enter)="authenticateAndFreeze()"
        />
      </div>
      <div class="mb-3">
        <label for="freezePassword" class="form-label">Password:</label>
        <div class="input-group">
          <input
            [type]="showFreezePassword ? 'text' : 'password'"
            class="form-control"
            id="freezePassword"
            [(ngModel)]="freezePassword"
            placeholder="Enter your password"
            (keyup.enter)="authenticateAndFreeze()"
          />
          <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="toggleFreezePasswordVisibility()"
          >
            <i class="bx" [class.bx-show]="!showFreezePassword" [class.bx-hide]="showFreezePassword"></i>
          </button>
        </div>
      </div>
      <div class="mb-3">
        <label for="freezeReason" class="form-label">Reason:</label>
        <textarea
          class="form-control"
          id="freezeReason"
          [(ngModel)]="freezeReason"
          rows="3"
          placeholder="Enter reason for {{ isFreezing ? 'freezing' : 'unfreezing' }} this Participant"
        ></textarea>
      </div>
      <div *ngIf="freezeError" class="text-danger mb-3">
        {{ freezeError }}
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn custom-button me-2" data-bs-dismiss="modal">
          Cancel
        </button>
        <button
          class="btn custom-button"
          (click)="authenticateAndFreeze()"
          [disabled]="!freezeEmail || !freezePassword || !freezeReason"
        >
          {{ isFreezing ? 'Freeze' : 'Unfreeze' }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Lock Subject Modal -->
<div
  class="modal fade"
  id="lockSubjectModal"
  tabindex="-1"
  aria-labelledby="lockSubjectModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content p-4">
      <h5 class="modal-title mb-3">Lock Participant</h5>
      <div class="mb-3">
        <p class="text-muted">
          <strong>Screening ID:</strong> {{ currentSubject?.subjectId }}
        </p>
        <div class="alert alert-danger">
          <h6><strong>Warning:</strong></h6>
          <ul class="mb-0">
            <li>Once locked, this Participant <strong>CANNOT be unlocked.</strong></li>
            <li>You will <strong>NOT be able to make any changes</strong> to this Participant.</li>
            <li>This action is <strong>IRREVERSIBLE.</strong></li>
          </ul>
        </div>
      </div>
      <div class="mb-3">
        <label for="lockEmail" class="form-label">Email:</label>
        <input
          type="email"
          class="form-control"
          id="lockEmail"
          [(ngModel)]="lockEmail"
          placeholder="Enter your email"
          (keyup.enter)="authenticateAndLock()"
        />
      </div>
      <div class="mb-3">
        <label for="lockPassword" class="form-label">Password:</label>
        <div class="input-group">
          <input
            [type]="showLockPassword ? 'text' : 'password'"
            class="form-control"
            id="lockPassword"
            [(ngModel)]="lockPassword"
            placeholder="Enter your password"
            (keyup.enter)="authenticateAndLock()"
          />
          <button
            class="btn btn-outline-secondary"
            type="button"
            (click)="toggleLockPasswordVisibility()"
          >
            <i class="bx" [class.bx-show]="!showLockPassword" [class.bx-hide]="showLockPassword"></i>
          </button>
        </div>
      </div>
      <div class="mb-3">
        <label for="lockReason" class="form-label">Reason:</label>
        <textarea
          class="form-control"
          id="lockReason"
          [(ngModel)]="lockReason"
          rows="3"
          placeholder="Enter reason for locking this Participant"
        ></textarea>
      </div>
      <div *ngIf="lockError" class="text-danger mb-3">
        {{ lockError }}
      </div>
      <div class="d-flex justify-content-end">
        <button class="btn custom-button me-2" data-bs-dismiss="modal">
          Cancel
        </button>
        <button
          class="btn btn-danger"
          (click)="authenticateAndLock()"
          [disabled]="!lockEmail || !lockPassword || !lockReason"
        >
          Lock Participant
        </button>
      </div>
    </div>
  </div>
</div>
